<template>
  <button
    class="btn btn-map"
    :class="customClass"
    @click.stop="$emit('click')"
    @keydown.enter.stop="$emit('click')"
    @keydown.space.stop.prevent="$emit('click')"
  >
    <img
      src="https://res.cloudinary.com/oredev/image/upload/v1716803684/2025/Icons/door.svg"
      alt=""
      aria-hidden="true"
    />
    Room: {{ room }}
  </button>
</template>
  
  <script>
export default {
  name: "RoomButton",
  props: {
    room: {
      type: String,
      required: true,
    },
    customClass: {
      type: [String, Array, Object],
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/styles/variables.scss" as *;
.btn-map {
  display: flex;
  align-items: center;
  gap: 4px; /* space between icon and text */

  padding: 2px 8px;
  text-transform: none;
  background-color: $lime-green;
  border: 2px solid $dark-brown;
  border-radius: 5px;
  box-shadow: 0px 2px 3px 0px #00000040;

  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.05rem;
  line-height: 100%;

  &:hover,
  &:focus-visible {
    outline: 2.5px solid $dark-brown !important;
    border: 2.5px solid $white !important;
  }

  img {
    width: 16px;
  }

  /* &:hover,
    &:focus-visible {
      background-color: $dark-brown;
      color: $lime-green;
    } */
}
</style>


// WEBPACK FOOTER //
// src/components/RoomButton.vue